import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

interface ActivityListState<Activity> {
  activities: Activity[] | null;
  setActivities: Dispatch<SetStateAction<Activity[] | null>>;
  problem: string | null;
  setProblem: Dispatch<SetStateAction<string | null>>;
}

export const useActivityList = <Activity, Repository>(
  repository: Repository,
  load: (repository: Repository) => Promise<Activity[]>,
  loadFailureMessage = 'Could not load activities.',
): ActivityListState<Activity> => {
  const [activities, setActivities] = useState<Activity[] | null>(null);
  const [problem, setProblem] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    void load(repository)
      .then((result) => {
        if (active) setActivities(result);
      })
      .catch((error: unknown) => {
        if (active) setProblem(error instanceof Error ? error.message : loadFailureMessage);
      });
    return () => {
      active = false;
    };
  }, [load, loadFailureMessage, repository]);

  return { activities, setActivities, problem, setProblem };
};

export const titleCase = (value: string): string => value[0]?.toUpperCase() + value.slice(1);
